import React from 'react';

import Input from './Input';

const rules = [{
    type: 'email',
    message: '邮箱格式不正确！',
    },{
    required: false,
    message: '请输入邮箱',
}];

const Email = (props) => (
    <Input label="邮箱" name="email" {...props} rules={rules}></Input>
);

export default Email;